{
  "Untitled event": "Wydarzenie bez tytułu",
  "Under a minute": "Poniżej minuty",
  "{minutes} min": "{minutes} min",
  "{hours} h {minutes} min": "{hours} godz. {minutes} min",
  "{hours} h": "{hours} godz.",
  "Under 1 MB": "Poniżej 1 MB",
  "{count} part": {
    "one": "{count} część",
    "few": "{count} części",
    "many": "{count} części"
  },
  "{count} recording": {
    "one": "{count} nagranie",
    "few": "{count} nagrania",
    "many": "{count} nagrań"
  },
  "data file|Event details": "Szczegóły wydarzeń",
  "Every event's title, date, place, link and settings": "Tytuł, data, miejsce, link i ustawienia każdego wydarzenia",
  "Guests and registrations": "Goście i rejestracje",
  "Names, emails, how each guest joined and what they watched": "Imiona i nazwiska, adresy e-mail, sposób dołączenia każdego gościa i obejrzane treści",
  "Guestbook messages": "Wiadomości w księdze gości",
  "Every message with its event, name and time": "Każda wiadomość z nazwą wydarzenia, imieniem autora i godziną",
  "Viewer counts": "Liczba widzów",
  "Live and replay viewers for each recording": "Widzowie na żywo i widzowie nagrania, osobno dla każdego nagrania",
  "Sales and donations": "Sprzedaż i darowizny",
  "Tickets, paid downloads and donations, with amounts and dates": "Bilety, płatne pobrania i darowizny z kwotami i datami",
  "This recording belongs to another account.": "To nagranie należy do innego konta.",
  "We couldn't find this recording. It may have been deleted.": "Nie znaleźliśmy tego nagrania. Mogło zostać usunięte.",
  "Downloads are temporarily unavailable. Please try again in a few minutes.": "Pobieranie jest chwilowo niedostępne. Spróbuj ponownie za kilka minut.",
  "Could not reach EventLive. Check your internet connection and try again.": "Nie udało się połączyć z EventLive. Sprawdź połączenie z internetem i spróbuj ponownie.",
  "Ready to download": "Gotowe do pobrania",
  "{count} recording is being prepared": {
    "one": "Przygotowujemy {count} nagranie",
    "few": "Przygotowujemy {count} nagrania",
    "many": "Przygotowujemy {count} nagrań"
  },
  "Download this one when one of them is ready.": "Pobierz to nagranie, gdy któreś z przygotowywanych będzie gotowe.",
  "Could not load your recordings.": "Nie udało się wczytać nagrań.",
  "Couldn't download the file": "Nie udało się pobrać pliku",
  "Still preparing. Long recordings take a while; you can leave this page and come back.": "Nadal trwa przygotowywanie. Długie nagrania wymagają trochę czasu — możesz opuścić tę stronę i wrócić później.",
  "Joining {parts} parts into one MP4. This usually takes a few minutes.": "Łączymy {parts} części w jeden plik MP4. Zwykle trwa to kilka minut.",
  "Preparing the MP4. This usually takes a few minutes.": "Przygotowujemy plik MP4. Zwykle trwa to kilka minut.",
  "This is taking much longer than usual. Try again, or contact support.": "Trwa to znacznie dłużej niż zwykle. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  "Couldn't prepare the download. Try again.": "Nie udało się przygotować pliku do pobrania. Spróbuj ponownie.",
  "In the Secure Archive, so it can't be downloaded. Restore it to download it again, or delete it.": "Jest w bezpiecznym archiwum, więc nie można go pobrać. Przywróć je, aby znów móc je pobrać, albo je usuń.",
  "In the Secure Archive, so it can't be downloaded. You can delete it.": "Jest w bezpiecznym archiwum, więc nie można go pobrać. Możesz je usunąć.",
  "Restore {title}": "Przywróć: {title}",
  "Delete {title}": "Usuń: {title}",
  "Download": "Pobierz",
  "Preparing…": "Przygotowywanie…",
  "Preparing {title}": "Przygotowywanie: {title}",
  "Try again: {title}": "Spróbuj ponownie: {title}",
  "Download {title}": "Pobierz: {title}",
  "Guestbook PDF · {count} message": {
    "one": "PDF księgi gości · {count} wiadomość",
    "few": "PDF księgi gości · {count} wiadomości",
    "many": "PDF księgi gości · {count} wiadomości"
  },
  "Download the guestbook of {title} as a PDF": "Pobierz księgę gości wydarzenia „{title}” w formacie PDF",
  "Download {title} (CSV)": "Pobierz: {title} (CSV)",
  "Deleted": "Usunięto",
  "Couldn't delete it": "Nie udało się usunąć",
  "Delete “{title}”?": "Usunąć „{title}”?",
  "The event, its recording, guest list and guestbook are deleted for good. This can't be undone.": "Wydarzenie, jego nagranie, lista gości i księga gości zostaną trwale usunięte. Tej operacji nie można cofnąć.",
  "Delete event": "Usuń wydarzenie",
  "Loading your recordings…": "Wczytywanie nagrań…",
  "one MP4 file each": "po jednym pliku MP4 na nagranie",
  "loading more…": "wczytywanie kolejnych…",
  "Download everything": "Pobierz wszystko",
  "Your recordings are yours. Download any of them, any time, free.": "Twoje nagrania należą do ciebie. Pobieraj je, kiedy chcesz, za darmo.",
  "Give a family or a couple their video, or keep your own archive.": "Przekaż wideo rodzinie lub parze albo prowadź własne archiwum.",
  "Download everything is for business accounts. To download a video, open its event and choose Download & View Stats.": "Funkcja „Pobierz wszystko” jest dostępna dla kont firmowych. Aby pobrać wideo, otwórz jego wydarzenie i wybierz „Pobierz i zobacz statystyki”.",
  "Recordings": "Nagrania",
  "Couldn't load your recordings": "Nie udało się wczytać nagrań",
  "No recordings yet": "Nie ma jeszcze nagrań",
  "When you stream an event or upload a video, it shows up here, ready to download.": "Gdy przeprowadzisz transmisję wydarzenia lub prześlesz wideo, nagranie pojawi się tutaj, gotowe do pobrania.",
  "Search for a recording": "Szukaj nagrania",
  "Search recordings by title, place or date": "Szukaj nagrań po tytule, miejscu lub dacie",
  "Clear search": "Wyczyść wyszukiwanie",
  "No recordings match “{query}”.": "Brak nagrań pasujących do „{query}”.",
  "Show {count} more": "Pokaż jeszcze {count}",
  "{count} recording found.": {
    "one": "Znaleziono {count} nagranie.",
    "few": "Znaleziono {count} nagrania.",
    "many": "Znaleziono {count} nagrań."
  },
  "Each MP4 joins every live session and upload in order, in the best quality we keep.": "Każdy plik MP4 łączy po kolei wszystkie sesje na żywo i przesłane pliki w najlepszej jakości, jaką przechowujemy.",
  "Long recordings are big files, so use a fast connection.": "Długie nagrania to duże pliki, więc korzystaj z szybkiego połączenia.",
  "It opens in your browser to save. Long recordings are big files: a computer on Wi-Fi is quickest.": "Plik otworzy się w przeglądarce, gdzie możesz go zapisać. Długie nagrania to duże pliki: najszybciej pójdzie na komputerze z Wi-Fi.",
  "Your data": "Twoje dane",
  "Spreadsheets for Excel, Numbers or Google Sheets, covering every event in your account": "Arkusze kalkulacyjne do Excela, Numbers lub Arkuszy Google ze wszystkimi wydarzeniami na twoim koncie",
  "One page with your events that anyone with the link can watch, and your ticketed events, newest first.": "Jedna strona z twoimi wydarzeniami, które może obejrzeć każdy, kto ma link, oraz z wydarzeniami z biletami — od najnowszych.",
  "Your Video Wall link": "Link do twojej Ściany wideo",
  "Video Wall link": "Link do Ściany wideo",
  "Copy Video Wall link": "Kopiuj link do Ściany wideo",
  "Open Video Wall": "Otwórz Ścianę wideo",
  "Embed on your website": "Osadź na swojej stronie internetowej",
  "Paste the code into your website's HTML or embed block.": "Wklej kod na swojej stronie internetowej: w jej HTML lub w bloku osadzania.",
  "Code type": "Typ kodu",
  "Script (recommended)": "Skrypt (zalecany)",
  "The wall grows to fit all your events instead of scrolling inside a box.": "Ściana powiększa się, aby zmieścić wszystkie twoje wydarzenia, zamiast przewijać się w ramce.",
  "Simple iframe (no script)": "Zwykły iframe (bez skryptu)",
  "For site builders that remove scripts. The wall scrolls inside the space your page gives it.": "Dla kreatorów stron, które usuwają skrypty. Ściana przewija się w miejscu, które zapewnia jej twoja strona.",
  "Copy embed code": "Kopiuj kod Embed",
  "Embed code copied": "Skopiowano kod Embed",
  "Paste it into your website's HTML.": "Wklej go do kodu HTML swojej strony internetowej."
}
